// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__O4_vq","filter":"style_filter__2XJKb","label":"style_label__3yC4n"};